import { render, staticRenderFns } from "./myAtlas.vue?vue&type=template&id=6f2a019a&scoped=true"
import script from "./myAtlas.vue?vue&type=script&lang=js"
export * from "./myAtlas.vue?vue&type=script&lang=js"
import style0 from "./myAtlas.vue?vue&type=style&index=0&id=6f2a019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a019a",
  null
  
)

export default component.exports